/**
 * 文件夹详情路由 · 统一指向新版「AI 智能分类」详情页。
 *
 * 历史上本模块还承担「团队是否命中 AI 分类白名单」的判定与新旧两版页面的
 * 路由守卫；AI 智能分类已全量上线、旧版「分类文件夹」入口下线后，判定与守卫
 * 一并移除，此处仅保留文件夹详情路径的单一出口，供各处导航复用。
 */

/**
 * 文件夹详情路由。
 *
 * @param folderID - 文件夹 ID
 * @returns AI 智能分类详情页路径 `/ai-classify/folder/:id`
 */
export function folderDetailPath(folderID: string | number): string {
  return `/ai-classify/folder/${folderID}`
}
